import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const refundHtml = `
<style>
.dark .bg-overlay::after, .dark .dark-bg, .dark .navbar-sticky-moved-up, .dark-bg, body.dark {
    background: #ffffff!important;
}
h1 {
    font-size: 2em;
}
h1, h2, h3 {
    font-weight: 700;
    line-height: 1.2;
    margin: 0 0 1em;
    margin-top: 20px !important;
}
h2 {
    font-size: 1.5em;
}

.wpembed-madewith, .wpembed-nav, ol, p, ul {
    margin-bottom: 1.5em;
}
.mainbox{
    width: 70%;
    background: aliceblue;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 25px;
    padding-left: 25px;
    border-radius: 30px;
    margin-top: 20px;
    margin-bottom: 20px;
}
.outerbox{
    width: 100%;
    background: white;
    text-align: -webkit-center;
}
</style>
</div>
  <section>
    <h1>Refund & Return Policy</h1>
    <p>Our policy is valid for a period of <strong>1 calendar day</strong> from the date of the purchase. If you are not satisfied with the service, you can ask for a refund. A pro-rated refund will be issued for the unused portion of the services. If the period of 1 day has lapsed since the purchase, we unfortunately can’t offer you a refund.</p>
    <h2>Additional Services</h2>
    <p>Please note that any additional services, custom work, or technical support are non-refundable as our time cannot be recovered.</p>
    <h2>Contacting Us</h2>
    <p>If you have any questions, concerns, or complaints regarding this refund policy, we encourage you to contact us using the details below:</p>
    <address>
      <a href="mailto:contact@techadr.co">contact@techadr.co</a><br />
      Office No.11, Vinayraj Regency Bld No.22, Opp. Baithak Cafe, Yashwant Shrushti, Boisar (W), 401501
    </address>
    <p><em>This document was last updated on January 17, 2024</em></p>
  </section>
`;

const RefundReturn = () => (
  <>
    <Header />
    <main className="legal-page-content" style={{ minHeight: "60vh", padding: "2rem 0", background: "rgba(255,255,255,0.95)", color: "#222" }}>
      <div className="container" style={{ maxWidth: 900, margin: "0 auto", background: "#fff", borderRadius: 12, boxShadow: "0 2px 16px rgba(0,0,0,0.07)", padding: "2.5rem 2rem" }}>
        <div dangerouslySetInnerHTML={{ __html: refundHtml }} />
      </div>
    </main>
    <Footer />
  </>
);

export default RefundReturn; 